import {useEffect, useRef, useState} from 'react';

import type {Props} from './types';

export const useController = ({resendTimeout}: Props) => {
  const [remainSec, setRemainSec] = useState(0);

  const timeout = useRef<number>(undefined);

  useEffect(() => {
    clearTimeout(timeout.current);

    setRemainSec(resendTimeout);
  }, [resendTimeout]);

  useEffect(() => {
    timeout.current = +setTimeout(() => {
      if (remainSec === 0) {
        clearTimeout(timeout.current);
      } else {
        setRemainSec(remainSec - 1);
      }
    }, 1000);

    return () => clearTimeout(timeout.current);
  }, [remainSec, resendTimeout]);

  return {remainSec};
};
